var render = function render(){var _vm=this,_c=_vm._self._c;return _c('master-company-instruction-per-module',{key:_vm.$route.query.type})
}
var staticRenderFns = []

export { render, staticRenderFns }